// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__239_A","container":"styles_container__RDJ1c","title":"styles_title__2C29e","wrapper":"styles_wrapper__1strv","answer":"styles_answer__3RMfT"};